import { serverTimestamp } from "firebase/firestore";

export function toArticleDoc(editorDoc) {
  const {
    articleId,
    slug,
    title,
    subtitle,
    status,
    level,
    category,          // string จาก EditorMock
    subCategory,       // string จาก EditorMock
    tags = [],
    author = {},
    cover = {},
    blocks = [],
    wordCount = 0,
    readTime = 1,
    publicStatus = true,
  } = editorDoc;

  return {
    // --- คีย์หลัก ---
    articleId,               // คงไว้เพื่ออ้างอิง
    slug,                    // จะถูกจองให้ไม่ซ้ำตอน publish
    title,
    subtitle: subtitle || "",
    status,                  // draft|published|archived
    level,

    // --- category/subCategory ให้มีทั้ง object + slug สำหรับคิวรี ---
    category: category
      ? { slug: slugify(category), name: category }
      : null,
    subCategory: subCategory
      ? { slug: slugify(subCategory), name: subCategory }
      : null,
    categorySlug: category ? slugify(category) : null,         // for query
    subCategorySlug: subCategory ? slugify(subCategory) : null,

    // --- tags: เก็บทั้งแสดงผลและ slug สำหรับค้นหา ---
    tagsDisplay: tags,                               // ใช้โชว์
    tagSlugs: tags.map(t => slugify(t)),             // ใช้ filter

    // --- ผู้เขียน/รูปปก ---
    author: {
      uid: author.uid || null,
      displayName: author.displayName || "Encraft Team",
    },
    cover: cover.imageUrl || "",                     // หน้าอ่านใช้เป็น URL string
    coverCaption: cover.alt || "",

    // --- ตัวเลข/สถานะเสริม ---
    /* views: editorDoc.views ?? 0,
    likesCount: editorDoc.likesCount ?? 0,
    bookmarksCount: editorDoc.bookmarksCount ?? 0, */
    wordCount,
    readTime,
    publicStatus,                                    // ถ้าจะใช้
    // --- เนื้อหา ---
    contentBlocks: mapBlocksToReader(blocks),

    // --- เวลา ---
    updatedAt: serverTimestamp(),
    // createdAt ใส่เฉพาะตอนสร้างครั้งแรก (ดูใน onSaveDraft ด้านล่าง)
  };
}

function mapBlocksToReader(blocks = []) {
  return blocks.map(b => {
    switch (b.type) {
      case "heading":
        return { type: "heading", text: b.data?.text ?? "", level: b.data?.level ?? 2, };
      case "paragraph":
        return { type: "paragraph", text: b.data?.text ?? "" };
      case "image":
        return {
          type: "image",
          src: b.data?.imageUrl ?? "",
          alt: b.data?.alt ?? "",
          caption: b.data?.alt ?? ""
        };
      case "code":
        return {
          type: "code",
          language: b.data?.language || "plaintext",
          code: b.data?.code || "",
          filename: undefined
        };
      case "quote":
        return { type: "quote", text: b.data?.text ?? "", cite: b.data?.cite ?? "" };
      default:
        return { type: "paragraph", text: "" };
    }
  });
}

export function slugify(str = "") {
  return str
    .toLowerCase()
    .normalize("NFD").replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}